import { render, staticRenderFns } from "./formula-details.vue?vue&type=template&id=75223851&"
import script from "./formula-details.vue?vue&type=script&lang=js&"
export * from "./formula-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports